<template>
  <el-dialog
    :title="$t('text.add_facility')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    v-if="dialogVisible"
    @close="closeDialog()"
    width="630px"
    class="batch-operation"
  >
    <div class="step-wrapper">
      <el-steps
        :active="activeCard"
        finish-status="success"
        simple
        class="add-building-step"
      >
        <el-step
          :title="$t('text.facility_information')"
          icon="el-icon-office-building"
          :class="activeCard === 0 ? 'active-step' : ''"
        ></el-step>
        <el-step
          :title="$t('text.floor_information')"
          icon="el-icon-school"
          :class="activeCard === 1 ? 'active-step' : ''"
        ></el-step>
        <el-step
          :title="$t('text.room_information')"
          icon="el-icon-help"
          :class="activeCard === 2 ? 'active-step' : ''"
        ></el-step>
      </el-steps>
    </div>
    <el-form
      v-show="activeCard === 0"
      label-width="120px"
      :model="form"
      size="mini"
      ref="form"
      :rules="rules"
      label-position="top"
      v-loading="loading"
    >
      <el-form-item :label="$t('text.facility_name')" prop="buildingName">
        <el-input
          v-model="form.buildingName"
          :placeholder="$t('text.facility_name')"
          class="wp-100"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.number_of_floors')" prop="numberOfFloors">
        <el-input-number
          v-model="form.numberOfFloors"
          :placeholder="$t('text.number_of_floors')"
          :min="1"
          step-strictly
          class="wp-100"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <BuildingFloorSetting
      ref="buildingFloor"
      :numberOfFloors="form.numberOfFloors"
      v-show="activeCard === 1"
    />
    <BuildingTree
      v-show="activeCard === 2"
      ref="buildingTree"
      :data="data"
      :allBuildings="allBuildings"
      @loadingChange="loadingChange"
      @saveSuccessfully="saveSuccessfully"
    />
    <div slot="footer" class="dialog-footer">
      <el-button
        type="text"
        class="back-btn"
        v-if="activeCard !== 0"
        @click="back()"
        ><i class="el-icon-arrow-left mr-5"></i
        >{{ $t('text.back').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="submit()"
        :loading="loading"
        v-if="activeCard === 2"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="common-btn min-w-80" @click="next()" v-else>{{
        $t('text.continue').toUpperCase()
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import BuildingTree from '@/components/manage/building/BuildingTree.vue'
import BuildingFloorSetting from '@/components/manage/building/BuildingFloorSetting.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      activeCard: 0,
      data: [
        {
          id: 0,
          label: '',
          type: 'building',
          children: [
            {
              id: Math.random(),
              label: '',
              type: 'floor',
              children: [
                {
                  id: Math.random(),
                  label: '',
                  type: 'room'
                },
                {
                  id: Math.random(),
                  label: '',
                  type: 'room'
                }
              ]
            }
          ]
        }
      ],
      form: {
        buildingName: '',
        numberOfFloors: 1
      },
      rules: {
        buildingName: [
          {
            required: true,
            message: this.$t('text.please_enter_facility_name'),
            trigger: 'blur'
          }
        ],
        numberOfFloors: [
          {
            required: true,
            message: this.$t('text.please_enter_number_of_floors'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    BuildingTree,
    BuildingFloorSetting
  },
  props: {
    allBuildings: {
      type: Array,
      require: true
    }
  },
  methods: {
    loadingChange(val) {
      this.loading = val
    },
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        buildingName: '',
        numberOfFloors: ''
      }
      this.activeCard = 0
      this.dialogVisible = false
    },
    next() {
      if (this.activeCard === 0) {
        this.$refs.form.validate(valid => {
          if (valid) this.activeCard++
        })
      } else if (this.activeCard === 1) {
        this.$refs.buildingFloor.$refs.form.validate(valid => {
          if (valid) {
            let structure = [
              {
                id: 0,
                label: this.form.buildingName,
                type: 'building',
                children: this.$refs.buildingFloor.generateBuildingStructure()
              }
            ]
            this.data = JSON.parse(JSON.stringify(structure))
            this.activeCard++
          }
        })
      }
    },
    back() {
      this.activeCard--
    },
    submit() {
      this.$refs.buildingTree.submit()
    },
    saveSuccessfully() {
      this.$emit('updateBuilding')
      this.closeDialog()
    }
  }
}
</script>
